import React from 'react';
import { palette } from '../../styles/theme';

export function EditRequestSVG ({ className, stroke = palette.icons, width = '32', height = '32' }) {
    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_16843_20180)">
                <path
                    d="M6.66663 6.66667C6.66663 5.95942 6.94758 5.28115 7.44767 4.78105C7.94777 4.28095 8.62605 4 9.33329 4H22.6666C23.3739 4 24.0521 4.28095 24.5522 4.78105C25.0523 5.28115 25.3333 5.95942 25.3333 6.66667V25.3333C25.3333 26.0406 25.0523 26.7189 24.5522 27.219C24.0521 27.719 23.3739 28 22.6666 28H9.33329C8.62605 28 7.94777 27.719 7.44767 27.219C6.94758 26.7189 6.66663 26.0406 6.66663 25.3333V6.66667Z"
                    stroke={stroke}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 9.33325H20" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 14.6667H20" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 20H17.3333" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
            <defs>
                <clipPath id="clip0_16843_20180">
                    <rect width="32" height="32" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    );
}
